{
    "TITLE" : "Remote Application",
    
        "SHARED": {
            "INTERNET_OFFLINE": "インターネット接続がオフラインです。",
            "LANGUAGE": "言語",
            "NO_FEATURE": "ライセンスにこの機能がありません。管理者に連絡してください。",
            "FEATURE_UNAVAILABLE": "ライセンスにこの機能がありません。",
            "APP_UPDATE_NEEDED": "To use this feature, this participant needs to update their app.",
            "TRAINING_DISABLED": "この機能を使う権限がありません。ホストに許可を要求してください。"
        },
        "UPDATE_MODAL": {
            "TITLE": "アップデートが利用可能です。",
            "MESSAGE": "新しいバージョンが利用可能です。このページはアップデート後にリロードされます。",
            "UPDATE": "リロード",
            "UPDATE_FAILED": "アップデートに失敗しました。"
        },
        "LOGIN" : {
        "SSO-BUTTON": "SSOでサインイン",
            "APP_NAME": "{{ appName }} Remote",
            "TITLE": "VSightにログインします",
            "ACCOUNT_PLACEHOLDER" : "アカウント名",
            "ACCOUNT_REQUIRED" : "アカウント名が必要です。",
            "ACCOUNT_SHORT" : "アカウント名には少なくとも2文字が必要です。",
            "USERNAME_PLACEHOLDER" : "ユーザー名",
            "USERNAME_REQUIRED" : "ユーザー名が必要です。",
            "USERNAME_SHORT" : "ユーザー名には少なくとも2文字が必要です。",
            "PASSWORD_PLACEHOLDER" : "パスワード",
            "PASSWORD_REQUIRED" : "パスワードが必要です。",
            "PASSWORD_SHORT" : "パスワードには少なくとも6文字が必要です。",
            "REMEMBER_ACCOUNT_NAME": "アカウント名を保存",
            "VERIFICATION_CODE": "確認コード",
            "TWO_FACTOR_EMAIL_SENDED": "確認コード付きのメールを送付しました。",
            "VERIFY_BUTTON": "確認",
            "LOGIN_BUTTON" : "ログイン",
            "BACK_BUTTON" : "バック",
            "BEFORE_TERMS": "ログインをクリックすると、利用規約に同意したことになります",
            "TERMS": "利用規約",
            "CONJUNCTION": " and ",
            "PRIVACY": "プライバシーポリシー",
            "AFTER_PRIVACY": ".",
            "GUEST_DELETED": "ログアウトしました。",
            "USER_DELETED": "アカウントが削除されています。管理者に連絡してください。",
            "USER_DISABLED": "アカウントが無効化されています。管理者に連絡してください。",
            "LOGGED_IN_ANOTHER_SESSION": "別のセッションで記録されています。",
            "LOGGED_OUT_UNKNOWN": "失敗しました。",
            "NO_INTERNET_ERROR": "インターネット接続されていません。接続設定を確認してください。",
            "USERNAME_PASSWORD_ERROR" : "アカウント名、ユーザー名もしくはパスワードが間違っています。",
            "ACCOUNT_DISABLED": "アカウントの有効期限が切れています。{{ contactMail }} まで連絡してください。",
            "INVALID_VERIFICATION_CODE" : "無効な二段階認証のコードです。",
            "UNKNOWN_ERROR" : "サインイン中にエラーが発生しました。",
            "SIMULTANE_LOGIN_ERROR": "別のセッションで記録されています。",
            "USE_CHINA_SERVERS": "中国からログインしています",
            "CHINA_SERVERS_CAUTION": "中国本土以外でこのオプションをつけると遅延が発生します。",
            "MULTI_LOGIN_MODAL": {
                "TITLE": "複数ログイン",
                "MESSAGE": "このユーザーは既に別のデバイスでログインされています。続けると、別のデバイスでのユーザーはサインアウトされます。",
                "CANCEL": "キャンセル",
                "PROCEED": "続行"
            }
        },
        "MAIN" : {
            "LICENSE_LEFT": "あと {{ days }} 日間利用可能な {{ appName }} リモートライセンスです。",
            "DEMO_LEFT": "あと {{ days }} 日間利用可能な {{ appName }} リモートトライアルライセンスです。",
            "LEFT_BAR": {
                "LOBBY": "ロビー",
                "ROOMS": "ルーム",
                "MEETINGS": "ミーティング",
                "FEEDBACK": "フィードバック",
                "CONTACTS": "ユーザー",
                "SESSIONS": "セッション",
                "TICKETS": "チケット",
                "PRECALL_TEST": "接続テスト",
                "WHATS_NEW": "新着情報",
                "PROFILE": "プロフィール",
                "HELP_CENTER": "ヘルプセンター",
                "LOGOUT": "ログアウト"
            },
            "CALL_MESSAGE": {
                "TITLE":"<strong>{{ caller_name }}</strong> からのコールです。",
                "DENY": "拒否",
                "ACCEPT": "応答"
            },
            "GET_EXPORT_MODAL": {
                "SEND": "送信", 
                "TITLE": "セッションの記録を取得",
                "MESSAGE1": "セッション終了後、記録をダウンロードするためのダウンロードリンクを取得するにはメールアドレスを入力してください。",
                "MESSAGE2": "セッションの記録にはチャット、スナップショット、映像、共有したファイルが含まれます。",
                "EXPORT_NAME_NOT_LOCKED": "代わりに、カスタマイズしたファイル名を入力して、エクスポートファイルの名前を変更できます。",
                "EXPORT_NAME_LOCKED": "他のユーザーがエクスポートを完了するとすぐに、エクスポートファイルの名前を変更できます。",
                "EXPORT_NAME_RENAMED": "エクスポートファイルは、このユーザーによって名前が変更されます。",
                "EXPORT_NAME_PLACEHOLDER": "エクスポート名",
                "NOTE": "Note:プロファイルメニューからメールアドレスを更新できます。",
                "NOTE2": "Note:管理者はデフォルトのメールアドレス設定を変更することができます。",
                "OPEN_PROFILE": "プロファイルを開く",
                "EMAIL": "Email",
                "EMAIL_REQUIRED": "Emailが必要です。",
                "EMAIL_INVALID": "無効なメールのフォーマットです。",
                "CLOSE": "閉じる",
                "EXPORT_SUCCEEDED": "セッションの記録はセッション終了後に送信されます。",
                "ENDED_SESSION_EXPORT_SUCCEEDED": "セッションのエクスポートが送信されます。",
                "EXPORT_FAILED": "エラーが発生しました。"
            },
            "EASY-ACCESS": {
                "MANAGE-PUBLIC-ACCESS": "公開アクセスを管理",
                "MANAGE-PUBLIC-ACCESS-TEXT": "公開アクセスを削除することで、このワークフローの共有を停止できます。",
                "GENEATE-ACCESS-TEXT": "このワークフローの簡単なアクセスを作成するために、公開リンクとQRコードを生成できます。",
                "ENABLE-PASSWORD": "パスワードを有効にする",
                "GENERATE-ACCESS": "生成",
                "LINK": "リンク",
                "COPY": "コピー",
                "QR-CODE": "QRコード",
                "DOWNLOAD": "ダウンロード",
                "SECURITY": "セキュリティ",
                "PASSWORD-PROTECTED": "パスワード保護",
                "PUBLIC": "公開",
                "DELETE-ACCESS": "公開アクセスを削除",
                "EASY-ACCESS-TITLE": "{{ shortName }} ワークフロー簡単アクセス",
                "OPEN-WORKFLOW-NAME": "開こうとしています",
                "GUEST-EMAIL": "ゲストメール",
                "REQUIRED": "このフィールドは必須です",
                "GUEST-PASSWORD": "ゲスト用パスワード",
                "OPEN": "開く",
                "OPEN-APP": "より良い体験のために、このワークフローをアプリで開くことをお勧めします。",
                "COPY-LINK-TEXT": "アプリが起動したときにこのワークフローを開くために、リンクをクリップボードにコピーします。",
                "DOWNLOAD-APP": "アプリをダウンロード",
                "DOWNLOAD-SMARTGLASSES-APP": "スマートグラス用アプリをダウンロード",
                "OR": "または",
                "CONTINUE-WITH-BROWSER": "ブラウザで続行",
                "PASSWORD-PROTECTED-TEXT": "パスワードが有効になっている場合、公開リンクまたはQRコードを持っているユーザーは、パスワードを入力した場合にのみこのワークフローにアクセスできます。",
                "CREATE-PASSWORD": "パスワードを作成",
                "ENTER-EMAIL": "メールアドレスを入力",
                "ENTER-WORKFLOW-PASSWORD": "ワークフローのパスワードを入力",
                "DELETE-QR-TEXT": "簡単アクセスのセキュリティタイプを変更するには、簡単アクセスを削除して再度生成する必要があります。",
                "LOADING-WORKFLOW": "ワークフローを読み込み中...",
                "UNABLE-TO-LOAD": "ワークフローを読み込めません",
                "RETRY": "再試行",
                "GUEST-ACCESS": {
                    "TOKEN-MISSING": "トークンが欠落しているか無効です",
                    "ID-MISSING": "ワークフローIDまたはベースURLが欠落しています",
                    "WORKFLOW-NOT-PUBLISHED": "ワークフローが公開されていません",
                    "PUBLIC-ACCESS": "公開アクセスは既に存在します",
                    "NO-PUBLIC-ACCESS": "公開アクセスがありません"
                },
                "QR-INFORMATION": "QR情報"
            },
            "VIDEO-FLOW-DASHBOARD": {
                "TITLE": "ビデオフロー",
                "CREATE-VIDEO-FLOW": "ビデオフローを作成",
                "CREATED-BY-AI": "AIによって作成",
                "VERSION": "バージョン",
                "NO-VIDEO-FLOWS-FOUND": "ビデオフローが見つかりません",
                "CLEAR-ALL": "すべてクリア",
                "CONFIRM-VIDEO": "ビデオを確認",
                "CONFIRM-VIDEO-TITLE": "ビデオ変換を確認",
                "CONFIRM-VIDEO-MESSAGE": "このビデオフローをワークフローに変換してもよろしいですか？確認後、ビデオを編集できなくなります。",
                "CONFIRM-VIDEO-BUTTON": "確認して変換",
                "MAKE-WORKFLOW-SUCCESSFUL": "ワークフローへの変換に成功しました",
                "MAKE-WORKFLOW-ERROR": "ワークフローへの変換に失敗しました",
                "UPLOAD-VIDEO-DESCRIPTION": "ビデオをアップロードして、ステップバイステップのワークフローガイドを自動生成します。",
                "VIDEO-DURATION-LIMIT": "ビデオの長さは30分を超えることはできません。",
                "VIDEO-UPLOADED-SUCCESS": "ビデオのアップロードに成功しました！",
                "SELECT-VIDEO": "ビデオを選択",
                "CHANGE-VIDEO": "ビデオを変更",
                "CREATE-BUTTON": "作成",
                "AI-PROCESSING": "AI処理中",
                "SPLITTING-VIDEO": "ビデオをセグメントに分割中",
                "TRANSCRIBING-VIDEO": "ビデオコンテンツを文字起こし中",
                "PROCESS-WARNING": "このプロセスには最大10分かかる場合があります。このウィンドウを閉じないでください。"
            },
            "NAVBAR" : {
                "PRECALL_TEST": "接続テスト",
                "PRECALL_END_SESSION": "接続テストの前にセッションを終了してください。",
                "LOGOUT" : "ログアウト",
                "LANGUAGE" : "言語",
                "LOGOUT_MODAL_TITLE": "ログアウトしますか？",
                "LOGOUT_MODAL_MESSAGE": "ログアウトします。",
                "CAUTION": "注意：これにより、セッションを終了せずにログアウトします。セッション後のポップアップウィンドウやその他の情報が失われる可能性があります（セッションのエクスポートなど）。",
                "LOGOUT_MODAL_MESSAGE_IN_ROOM": "セッションを終了してログアウトします。",
                "LOGOUT_MODAL_NO": "キャンセル",
                "LOGOUT_MODAL_YES": "ログアウト",
                "LOGOUT_FAILED": "ログアウト時にエラーが発生しました。",
                "HELP_CENTER": "ヘルプセンター",
                "PROFILE_TITLE": "プロフィール",
                "PROFILE_NAME": "アカウント名",
                "PROFILE_EMAIL": "Email",
                "PROFILE_PASSWORD": "パスワード",
                "PROFILE_CHANGE_LINK": "変更",
                "PROFILE_ADD_LINK": "追加",
                "PROFILE_CLOSE": "閉じる",
                "CHANGE_PASS_TITLE": "パスワード変更",
                "CHANGE_PASS_OLD_PASS": "現在のパスワード",
                "CHANGE_PASS_NEW_PASS": "新しいパスワード",
                "CHANGE_PASS_RPT_PASS": "パスワードを認証する",
                "CHANGE_PASS_REQUIRED": "パスワードが必要です。",
                "CHANGE_PASS_NOT_MATCH": "パスワードが一致しません",
                "CHANGE_PASS_CLOSE_BTN": "閉じる",
                "CHANGE_PASS_CHANGE_BTN": "パスワード変更",
                "CHANGE_PASS_SUCCESS": "パスワードが変更されました。",
                "CHANGE_PASS_WRONG": "パスワードが違います。",
                "CHANGE_PASS_FAILED": "パスワード変更に失敗しました。",
                "CHANGE_EMAIL_TITLE": "メールアドレスを変更",
                "CHANGE_EMAIL_NEW_EMAIL": "新しいメール",
                "CHANGE_EMAIL_RPT_EMAIL": "Eメール確認",
                "CHANGE_EMAIL_REQUIRED": "メールが必要です.",
                "CHANGE_EMAIL_NOT_VALID": "メールが無効です.",
                "CHANGE_EMAIL_NOT_MATCH": "メールアドレスが一致しません.",
                "CHANGE_EMAIL_CLOSE_BTN": "閉じる",
                "CHANGE_EMAIL_CHANGE_BTN": "メールアドレスを変更",
                "CHANGE_EMAIL_SUCCESS": "メールアドレスが変更されました.",
                "CHANGE_EMAIL_FAILED": "メールの変更に失敗しました.",
                "FEEDBACK": "Feedback",
                "SUCCESS_MESSAGE": "フォームを送信していただきありがとうございます。私たちのチームはまもなくご連絡いたします。",
                "CLOSE": "閉じる",
                "CREATE_NEW_PASS": "パスワード要件",
                "UPPERCASE": "大文字",
                "LOWERCASE": "小文字",
                "NUMBER": "番号",
                "SPECIAL": "特殊な",
                "AT_LEAST_PASSWORD_LENGTH": "少なくとも{{passwordlength}}文字",
                "OLD_PASSWORD": "以前のパスワード",
                "NOT_WHITESPACE": "パスワードにスペース文字を含めることはできません",
                "DO_NOT_CREATE_SIMPLE": "「123456」のような弱いパスワードを作成しないでください",
                "STATUS": {
                    "AVAILABLE": "利用可能",
                    "BUSY": "忙しい",
                    "APPEAR_OFFLINE": "オフラインで表示"
                }
            },
            "LOBBY" : {
                "LOBBY_SHARED": {
                    "ONGOING_CALLS_TITLE": "進行中のコール",
                    "ROOMS_TITLE": "ルーム",
                    "UPCOMING_MEETINGS_TITLE" : "今後の会議",
                    "PREVIOUS_MEETINGS_TITLE" : "以前の会議",
                    "SCHEDULE_MEETING": "スケジュール会議",
                    "INSTANT_GUEST_ACCESS": "インスタントゲストアクセス",
                    "INSTANT_GUEST_ACCESS_NO_CALLING": "通話を行う権限がありません。管理者にお問い合わせください。",
                    "INSTANT_GUEST_ACCESS_NO_GUEST_ACCESS": "ゲストアクセスリンクを作成する権限がありません。管理者にお問い合わせください。",
                    "INSTANT_GUEST_ACCESS_NO_PERM": "通話やゲストアクセスリンクの作成権限がありません。管理者にお問い合わせください。",
                    "LINK_UNAVAILABLE": "リンクが利用できません",
                    "JOIN" : "参加",
                    "CANCEL": "キャンセル",
                    "REMOVE": "削除する",
                    "NO_ROOM": "参加可能なルームがありません。",
                    "NO_MEETING": "会議はありません。",
                    "NO_PREV_MEETING": "会議はありません。",
                    "NO_OTHER_USERS": "他のユーザーがいません。",
                    "SHOW_MORE": "{{count}}をもっと見る",
                    "SHOW_LESS": "表示を減らす"
                },
                "SCHEDULE_MEETING_MODAL": {
                    "TITLE": "スケジュール会議",
                    "MEETING_TITLE": "タイトル*",
                    "MEETING_TITLE_REQUIRED": "タイトルが必要です。",
                    "START_DATE": "開始",
                    "END_DATE": "終わり",
                    "CLOSE": "閉じる",
                    "SCHEDULE_SEND": "スケジュールと送信",
                    "SCHEDULE": "スケジュール",
                    "CANNOT_SCHEDULE": "会議のスケジュール中にエラーが発生しました。",
                    "CANNOT_CANCEL_MEETING": "会議のキャンセル中にエラーが発生しました。",
                    "ENTER_USERS": "ユーザーを入力してください",
                    "SEND_INVITATIONS": "招待状を送信する",
                    "INVITATION_EMAIL_LANG": "招待メールの言語",
                    "SHARE_AFTER": "会議のリンクは、スケジュール後に共有することもできます。"
                },
                "CANCEL_MEETING_MODAL": {
                    "CANCEL_TITLE": "会議をキャンセルする",
                    "REMOVE_TITLE": "会議を削除する",
                    "CANCEL_MESSAGE": "会議をキャンセルしてもよろしいですか？",
                    "REMOVE_MESSAGE": "会議を削除してもよろしいですか？",
                    "CLOSE": "閉じる",
                    "PROCEED": "続行します"
                },
                "CONTACTS": {
                    "TITLE": "ユーザー",
                    "NO_PERMISSION": "ユーザーリストとコールを見る権限がありません。",
                    "NO_CONTACT": "ユーザーリストは空です。",
                    "SELECT_MULTI": "複数選択",
                    "CALL": "コール",
                    "ADMIN": "管理者",
                    "COADMIN": "共同管理者",
                    "EXPERT": "ルーム主催者",
                    "SUBSCRIBER": "参加者",
                    "USER": "ユーザー",
                    "NAME": "名前",
                    "USERNAME": "ID",
                    "ROLE": "役割",
                    "NO_EXPERT": "コールを行うには少なくとも1人のルーム主催者が必要です。",
                    "NAME_USERNAME": "名前またはユーザー名",
                    "ALL_ROLES": "すべての役割"
                },
                "SESSIONS": {
                    "TITLE": "セッション",
                    "DATE": "作成場所 ",
                    "DURATION": "総期間",
                    "ROOM_NAME": "ルーム",
                    "NO_SESSIONS": "セッションリストは空です。",
                    "PARTICIPANTS": "参加者",
                    "EXPORT": "輸出",
                    "STATUS": "スターテス",
                    "ON_GOING": "進行中",
                    "ENDED": "終了しました",
                    "FILES": "ファイル",
                    "CHAT": "チャット",
                    "SESSION_FILES": {
                        "MULTIPLE_SELECTION": "複数選択",
                        "DOWNLOAD": "ダウンロード",
                        "DOWNLOAD_STARTED_SOON": "ダウンロードはすぐに開始されます。",
                        "DOWNLOAD_FAILED": "ダウンロードに失敗しました",
                        "NO_FILE_IS_ADDED": "このセッションでは、ファイルは追加または共同編集されません。",
                        "SUCCESS_MESSAGE": "ファイルは正常にダウンロードされました。"
                    },
                    "ATTACHED_TICKET": "添付チケット",
                    "SESSION_DETAILS": "セッションの詳細",
                    "BACK": "戻る",
                    "GET_SESSION_EXPORT": "セッションのエクスポートを取得",
                    "ATTACH_TO_TICKET": "チケットに添付"
                },
                "TICKETS": {
                    "TITLE": "チケット",
                    "NEW_TICKET": "新しいチケット",
                    "ALL_ROOMS": "全てのルーム",
                    "ALL_STATUSES": "全てのステータス",
                    "NO_TICKETS": "チケットリストは空です。",
                    "TICKET_TITLE": "タイトル",
                    "ROOM": "ルーム",
                    "CREATED_BY": "作成者 ",
                    "CREATED_ON": "作成場所 ",
                    "STATUS": "ステータス",
                    "STATUS_OPEN": "開始前",
                    "STATUS_IN_PROGRESS": "進行中",
                    "STATUS_CLOSED": "終了",
                    "CLOSE_PICK_TICKET": "閉じる",
                    "CREATE_NEW": "新規作成",
                    "ATTACH": "添付",
                    "CREATE_TICKET": "チケット作成",
                    "TICKET_DETAILS": "チケット詳細",
                    "EDIT": "編集",
                    "TICKET_TYPE": "チケットの種類",
                    "ROOM2": "ルーム: ",
                    "CREATED_BY2": "作成者: ",
                    "CREATED_ON2": "作成場所: ",
                    "ROOM3": "ルーム",
                    "STATUS2": "ステータス",
                    "PRIORITY": "優先事項",
                    "ASSIGNEE": "担当者",
                    "FOLLOW_UP": "フォローアップ日",
                    "TICKET_TITLE2": "タイトル",
                    "TITLE_REQUIRED": "タイトルが必要です",
                    "DESCRIPTION": "説明",
                    "DESCRIPTION_REQUIRED": "説明が必要です",
                    "RESOLUTION": "解決",
                    "ATTACHED_SESSIONS": "添付されたセッション",
                    "NO_ATTACHED_SESSIONS": "添付されたセッションのリストが空です。",
                    "SESSION_COUNT": "セッション数: ",
                    "TOTAL_DURATION": "総期間: ",
                    "PARTICIPANTS2": "参加者:",
                    "COUNT_SESSIONS": " {{count}} セッション",
                    "DATE": "日付",
                    "ROOM_NAME": "ルーム名",
                    "PARTICIPANTS": "参加者",
                    "DURATION": "期間",
                    "GUEST": "(ゲスト)",
                    "CANCEL": "キャンセル",
                    "CLOSE": "閉じる",
                    "SAVE": "保存",
                    "CREATE": "作成",
                    "CREATED_BETWEEN": "間に作成",
                    "ALL_CREATORS": "すべてのクリエイター",
                    "SEND_VIA_EMAIL": "メールで送信",
                    "DELETE_TICKET": "チケットを削除",
                    "DELETE_TICKET_MODAL": {
                        "TITLE": "チケットを削除しますか？",
                        "MESSAGE":"本当に<strong>{{title}}</strong>を削除してよろしいですか？",
                        "CANCEL": "キャンセル",
                        "DELETE": "削除"
                    },
                    "LOW": "低",
                    "MEDIUM": "中",
                    "HIGH": "高",
                    "CHOOSE_TICKET": "チケットを選択",
                    "ERRORS": {
                        "TICKET_ALREADY_ATTACHED": "チケットはすでに添付されています。",
                        "ERROR_OCCURED": "エラーが発生しました。",
                        "PERMISSION_DENIED": "許可が拒否されました。",
                        "MISSING_PARAMETERS": "パラメータが不足しています",
                        "FILE_ALREADY_EXIST": "ファイルはすでに存在します"
                    },
                    "FILES": "ファイル",
                    "UPLOAD_FILE": "ファイルをアップロードする"
                },
                "ARCHIVES": {
                    "ARCHIVE_LIST": {
                        "LOADING": "読み込み中",
                        "CREATED_AT": "次の場所で作られました",
                        "SIZE": "サイズ",
                        "STATUS": "状態",
                        "DOWNLOAD": "ダウンロード",
                        "AVAILABLE": "利用可能",
                        "DISCONNECTED": "切断しました",
                        "DELETED": "削除しました",
                        "EXPIRED": "期限が切れました",
                        "WAITING": "待機中",
                        "FAILED": "失敗",
                        "REFRESH": "更新",
                        "NO_ARCHIVE_MESSAGE": "ビデオ通話の記録はありません",
                        "NAME": "名前",
                        "STORAGE": "保管所",
                        "DURATION": "間隔",
                        "ARCHIVES": "ビデオ通話記録",
                        "PLAY": "遊ぶ",
                        "DELETE": "消去",
                        "DOWNLOAD_ARCHIVE": {
                            "TITLE": "レコードをダウンロード",
                            "GENERATING": "ダウンロードURLの生成",
                            "GENERATED": "生成されたダウンロード",
                            "CANNOT_GENERATED": "ダウンロードURLを生成できません。",
                            "DOWNLOAD": "ダウンロード",
                            "CLOSE": "選ぶ"
                        },
                        "DELETE_ARCHIVE": {
                            "TITLE": "レコードを削除",
                            "MESSAGE": "ビデオハングアウトの記録は削除されます。",
                            "CAUTION": "注意：このレコードは、Azureストレージからも削除されます。",
                            "CANCEL": "キャンセル",
                            "DELETE": "消去"
                        }
                    }
                },
                "CONVERTER": {
                    "TITLE": "コンバータ",
                    "STP_ONLY": ".stpおよび.stepファイル形式のみがサポートされています.",
                    "ERROR_UPLOAD": "ファイルのアップロード中にエラーが発生しました.",
                    "DRAG": "ここにファイルをドラッグアンドドロップします",
                    "OR": "また",
                    "CHOOSE": "ファイルを選ぶ",
                    "CONVERT": "変換",
                    "SUPPORTED": "サポートされているファイル形式：",
                    "BACK": "バック",
                    "DOWNLOAD": "ダウンロード",
                    "ERROR_LOAD": "オブジェクトのロード中にエラーが発生しました."
                },
                "WHATSNEW": {
                    "WHATSNEW_TITLE": "新着情報",
                    "NO_UNREAD_UPDATE": "未読の更新はありません"
                },
                "JOIN_MODAL": {
                    "JOIN" : "参加",
                    "CALL": "コール",
                    "CANCEL": "キャンセル",
                    "MIRROR_VIDEO": "ミラービデオ",
                    "PREFERRED_RESOLUTION": "推奨される解決策",
                    "RESOLUTION_NOTE": "注：デバイスが要求した解像度をサポートできない場合は、次に大きい解像度が使用されます。",
                    "CAM_MIC_PERM_REQUIRED": "カメラとマイクの許可が必要です。",
                    "CAM_MIC_PERM_DENIED": "カメラとマイクへのアクセスが拒否されました。",
                    "CAM_MIC_CANT_ACCESS": "カメラとマイクにアクセスできません。",
                    "JOIN_CAM_OFF": "カメラをオフにして参加",
                    "JOIN_MIC_OFF": "マイクをオフにして参加",
                    "JOIN_CAM_MIC_OFF": "カメラとマイクをオフにして参加",
                    "JOIN_NO_DEVICE": "カメラとマイクなしで参加",
                    "ALLOW_ACCESS": "ブラウザの設定でカメラとマイクへのアクセスを許可する必要があります（アクセスを許可した後でも、カメラまたはマイクをオフにすることができます）。",
                    "TRY_AGAIN": "ページを再試行/更新し、ブラウザのプロンプトが表示されたら[許可]を選択します。"
                },
                "NO_DEVICE_MODAL": {
                    "TITLE": "デバイスが見つかりません",
                    "JOIN_BODY": "このデバイスに接続されているマイクとカメラはありません。 他のユーザーは、このデバイスを通してあなたの声を聞いたり見たりすることはできません。 それでも参加しますか？",
                    "CALL_BODY": "このデバイスに接続されているマイクとカメラはありません。 他のユーザーは、このデバイスを通してあなたの声を聞いたり見たりすることはできません。 それでも電話しますか？",
                    "CANCEL": "キャンセル",
                    "JOIN": "とにかく参加する",
                    "CALL": "とにかく電話する"
                },
                "AGREEMENT_MODAL": {
                    "TITLE": "個人データ承認フォームの処理とセキュリティ",
                    "REJECTION_BUTTON": "拒否する",
                    "AGREEMENT_BUTTON": "同意する"
                },
                "CHECK_AGREEMENT_MODAL": {
                    "TITLE": "契約をキャンセルしますか？",
                    "ERROR": "エラーが発生しました。",
                    "STATEMENT": "契約に同意しない場合、システムにログインすることはできません。",
                    "CANCEL_BUTTON": "キャンセル",
                    "PROCEED_BUTTON": "続行します"
                },
                "JOIN_UNKNOWN_ERROR" : "ルーム参加時にエラーが発生しました。",
                "JOIN_CONCURRENT_ERROR" : "現在のユーザー数の上限に達しました。詳細については管理者に連絡してください。",
                "JOIN_EXPERT_CONCURRENT_ERROR": "ルーム主催者ユーザー数の上限に達しました。詳細については管理者に連絡してください。",
                "NO_TRAINING_LICENSE": "トレーニングルームライセンスについて問題が発生しました。管理者に連絡してください。",
                "TRAINING_LICENSE_EXPIRED": "トレーニングルームライセンスが切れています。管理者に連絡してください。",
                "ASK_TRAINING_HOST": "トレーニングルーム参加中にエラーが発生しました。ホストに連絡してください。",
                "JOIN_CALL_IN_PROGRESS": "あなたのパーソナルミーティングルームにもう一つコールが届きました。",
                "NOT_SUPPORTED_TITLE": "非対応のブラウザ",
                "NOT_SUPPORTED_MESSAGE": "お使いのブラウザには対応しておりません。Google Chrome, Mozilla Firefox, Safari, Microsoft Edge (version 79 以上)をお使いください。",
                "NO_IOS_MESSAGE": "お使いのブラウザには対応しておりません。{{ appName }} リモートアプリもしくは Safari をお使いください。.",
                "IOS_VERSION_MESSAGE": "お使いのブラウザには対応しておりません。{{ appName }} リモートアプリをお使いください。.",
                "NOT_SUPPORTED_CLOSE": "閉じる",
                "IDLE_MODAL_TITLE": "エラー",
                "IDLE_MODAL_MESSAGE": "長時間の間使用されておりませんでした。",
                "IDLE_MODAL_COUNT": "あと {{ count }} 秒後にログアウトします。",
                "IDLE_MODAL_OK": "戻りました。",
                "ARCHIVE_PERMISSION_MODAL": {
                    "TITLE": "録画を許可しました。",
                    "MESSAGE": "このルームでの映像は録画されています。参加するには録画を許可する必要があります。",
                    "DENY": "拒否",
                    "ALLOW": "許可"
                }
            },
            "ROOM" : {
                "OT_ERROR_MODAL": {
                    "TITLE": "エラー",
                    "CLOSE": "閉じる",
                    "REJOIN": "再参加",
                    "ENDCALL": "離れる",
                    "ERRORS": {
                        "INTERNET": "セッションに接続できません。インターネット接続を確認してください。",
                        "TRY_AGAIN": "セッションに接続中にエラーが発生しました。時間をおいて再度お試しください。",
                        "UNKNOWN": "セッションに接続中にエラーが発生しました。",
                        "PUBLISHER_FAILED": "ビデオの共有に失敗しました。",
                        "PUBLISHER_CAM_MIC_ACCESS": "カメラとマイクが動作し、接続する許可が得られているか確認してください。",
                        "SUBSCRIBER_FAILED": "参加者のビデオへの接続に失敗しました。"
                    }
                },
                "SIDEBAR" : {
                    "CHAT_TITLE" : "チャット",
                    "PARTICIPANTS_TITLE" : "参加者",
                    "FILES_TITLE" : "ファイル",
                    "SETTINGS_TITLE" : "設定",
                    "SHOW_TICKET": "チケットを見せる",
                    "ATTACH_TO_TICKET": "チケットを添付",
                    "ATTACH_SESSION_TO_TICKET": "セッションへチケットの添付",
                    "OPEN_WORKFLOW": "ワークフローを開く",
                    "CHAT" : {
                        "SEE_TRANSLATION": "翻訳する",
                        "SEE_ORIGINAL": "原文を見る",
                        "TRANSLATING": "翻訳中",
                        "FILE_SHARE" : {
                            "DRAG_HERE" : "ここへファイルをドラッグ",
                            "UPLOAD_TITLE": "ファイルのアップロード",
                            "IMAGE": "画像",
                            "PDF": "PDF",
                            "3D_OBJECT": "3D オブジェクト",
                            "OTHER": "その他",
                            "MULTIPLE_OBJECTS": "複数のオブジェクトが見つかりました。一度に一つのオブジェクト(テクスチャがあれば合わせて)をアップロードしてください。",
                            "LARGER_THAN": "{{ megabytes }}MBより大きい",
                            "FILETYPE_PROHIBITED": "禁止されているファイルタイプ",
                            "START_UPLOAD": "アップロード",
                            "CANCEL_UPLOAD": "停止",
                            "CLOSE_UPLOAD": "閉じる",
                            "CANCEL_MODAL_TITLE": "アップロードを停止しますか？",
                            "CANCEL_MODAL_MESSAGE": "現在のアップロードを中止します。",
                            "CANCEL_MODAL_CLOSE": "キャンセル",
                            "CANCEL_MODAL_CANCEL": "停止"
                        },
                        "DELETE_FILE_MODAL": {
                            "TITLE": "ファイルの削除",
                            "MESSAGE": "ファイルが削除されます。",
                            "CLOSE": "閉じる",
                            "DELETE": "削除"
                        },
                        "FILE_DETAILS_MODAL": {
                            "TITLE": "ファイル詳細",
                            "FILENAME": "ファイル名",
                            "SIZE": "サイズ",
                            "TYPE": "タイプ",
                            "UPLOAD_TIME": "アップロード時間",
                            "DOWNLOAD": "ダウンロード",
                            "CLOSE": "閉じる",
                            "FILECOUNT": "総ファイル数"
                        },
                        "COLLABORATE": "共有",
                        "CLOSE_COLLABORATION": "コラボレーションを閉じる",
                        "DOWNLOAD": "ダウンロード",
                        "DELETE": "削除",
                        "DETAILS": "詳細",
                        "SEND_TO_FILES": "ファイルに送信",
                        "FILE_DELETED": "ファイルが削除されました",
                        "JOIN_ROOM" : "{{ owner_info }}がルームに参加しました。",
                        "LEAVE_ROOM" : "{{ owner_info }}がルームから退出しました。",
                        "REACTION": "{{ owner_info }}がリアクションを送りました。",
                        "REQUEST_SCREENSHOT": "{{ owner_info }}がスナップショットを要求しました。",
                        "SHARE_SCREENSHOT" : "{{ owner_info }}がスナップショットを共有しました。",
                        "SAVED_COLLABORATION": "コラボレーションが記録されました。",
                        "SHARE_IMAGE" : "{{ owner_info }}が画像を共有しました。",
                        "SHARE_PDF" : "{{ owner_info }}がPDFを共有しました。",
                        "SHARE_OTHER" : "{{ owner_info }}がファイルを共有しました。",
                        "SHARE_OBJECT" : "{{ owner_info }}が3Dオブジェクトを共有しました。",
                        "COLLABORATED" : "{{ owner_info }}がコラボレーションを開始しました。",
                        "TYPE_HERE" : "こちらに入力してください",
                        "PLEASE_WAIT_OTHERS": "他のユーザーが参加するまでお待ちください。",
                        "DOWNLOAD_STARTED_SOON": "ダウンロードはすぐに開始されます。",
                        "DOWNLOAD_FAILED": "ダウンロードに失敗しました",
                        "DOWNLOAD_OBJECT_NOT_SUPPORTED": "オブジェクトのダウンロードはまだサポートされていません。",
                        "DOWNLOAD_NOT_SUPPORTED": "ダウンロードはまだサポートされていません",
                        "CLOSE_PREV_COLLABORATION_TITLE": "現在のファイルコラボレーションを閉じますか？",
                        "CLOSE_COLLABORATION_TITLE": "ファイルコラボレーションを閉じますか？",
                        "CLOSE_PREV_COLLABORATION_MESSAGE": "現在のファイルコラボレーションを閉じて新しく開きます。",
                        "CLOSE_COLLABORATION_MESSAGE": "現在のファイルコラボレーションを閉じます。",
                        "CLOSE_PREV_COLLABORATION_YES": "続行",
                        "CLOSE_PREV_COLLABORATION_NO": "キャンセル",
                        "DISABLE_FOCUS_MODAL": {
                            "TITLE": "ファイルコラボレーションを開きますか？",
                            "MESSAGE_AUTHORIZED": "ピン止めされたウィンドウがあります。外してファイルコラボレーションを開きますか？",
                            "MESSAGE_UNAUTHORIZED": "ピン止めされたウィンドウがあるため、ファイルコラボレーションを開けませんでした。",
                            "CANCEL": "キャンセル",
                            "CLOSE": "閉じる",
                            "PROCEED": "続行"
                        },
                        "CLOSE_ARPLUS_BEFORE_COLL": {
                            "TITLE": "AR+を閉じますか？",
                            "MESSAGE": "コラボレーションを開く前に、AR +を閉じる必要があります。 AR +を閉じてもよろしいですか？",
                            "NO": "いいえ",
                            "YES": "はい"
                        }
                    },
                    "PARTICIPANTS": {
                        "HOST": "(ホスト)",
                        "LOWER_ALL_HANDS": "手を全て下げる",
                        "RAISED_HAND": "{{ name }}が挙手しました。",
                        "DENIED_PUBLISH": "{{ name }}がビデオ/音声共有を拒否しました。",
                        "PARTICIPANT_LIMIT_REACHED": "ビデオ/音声共有可能な参加者の上限に達しました。",
                        "CALLING": "{{ participants }}にコールしています。"
                    },
                    "FILES": {
                        "INFO_TEXT": "このルームへのアクセス権を持つすべての専門家と共同管理者は、このセクションのファイルを表示および変更できます",
                        "DOWNLOAD": "ダウンロード",
                        "SEND_TO_SESSION": "セッションに送信",
                        "DELETE": "消去",
                        "UPLOAD_FILE": "ファイルをアップロードする",
                        "FILE_CONTENTS": "ファイルの内容:",
                        "FILE_NAME": "ファイル名：",
                        "FILE_SIZE": "ファイルサイズ：",
                        "TOTAL_SIZE": "全体の大きさ：",
                        "DOWNLOAD_STARTED_SOON": "ダウンロードはすぐに開始されます。",
                        "DOWNLOAD_FAILED": "ダウンロードに失敗しました",
                        "DELETE_MODAL": {
                            "TITLE_DELETE": "ファイルを削除する？",
                            "MESSAGE_DELETE": "このファイルを削除してもよろしいですか?",
                            "CANCEL": "キャンセル",
                            "DELETE": "消去"
                        }
                    },
                    "SETTINGS": {
                        "MICROPHONE": "マイク",
                        "CAMERA": "カメラ",
                        "TRANSLATE_OTHERS_MSG_TO": "他人のメッセージを次の言語に翻訳:",
                        "TRANSLATE_MY_MSG_TO": "送信するメッセージを次の言語に翻訳:",
                        "CREATE_GUEST_ACCESS": "ゲストアクセスの作成",
                        "GENERATING": "作成中",
                        "GUEST_ACCESS": "ゲストアクセス",
                        "COPY_LINK": "コピー",
                        "LINK_COPIED": "リンクをクリップボードにコピー",
                        "LINK_GENERATED": "ルーム参加用リンクが作成されました。",
                        "CANNOT_CREATE_GUEST_ACCESS": "ゲストアクセスを作成できません。",
                        "NO_LINK_PERMISSION": "ゲストアクセスリンクを作成する権限がありません。管理者に連絡してください。",
                        "SHARE": "共有",
                        "SHARE_LINK_VIA_SMS": "SMS経由でリンクを共有する",
                        "SMS_SEND": "SMS経由で送信されたリンク",
                        "OPENING": "オープニング",
                        "SEND": "送信",
                        "SMS_LIMIT_REACHED": "SMS送信制限に達しました。管理者に連絡してください。",
                        "ERROR_OCCURED": "エラーが発生しました。",
                        "SMS_LICENSE_PERMISSION": "SMSを送信する権限がありません。管理者に連絡してください。",
                        "RESHARE": "リンクは1分に1回共有できます。",
                        "DIDNT_GET": "リンクを取得できませんでしたか？",
                        "PHONE_NUMBERS": "最近使用した電話番号",
                        "RESEND": "再送",
                        "CANCEL": "キャンセル",
                        "CONNECT_VIA_FIELD_CODE": "フィールドIDを介してユーザーと接続する",
                        "CONNECT": "接続",
                        "INVITATION_SENT": "招待状がユーザーに送信されました。",
                        "INVITATION_COULD_NOT_SENT": "招待状をユーザーに送信できませんでした。",
                        "FIELD_CODE": "フィールドID"
                    }
                },
                "VIDEO_CHAT" : {
                    "AUDIO_BITRATE": "オーディオビットレート",
                    "AUDIO_PACKET_LOSS": "オーディオパケット損失",
                    "VIDEO_BITRATE": "ビデオビットレート",
                    "VIDEO_PACKET_LOSS": "ビデオパケット損失",
                    "RESOLUTION": "解像度",
                    "WAIT_OTHER_USERS" : "他のユーザーが参加するまでお待ちください。",
                    "WAIT_EXPERT": "ルーム主催者が参加するまでお待ちください。",
                    "WAIT_MASTER": "ホストがセッションを開始するまでお待ちください。",
                    "START_SESSION": "セッション開始",
                    "HOST_WITHDRAW_REQUEST": "ホストがビデオ/音声の要求を取り下げました。",
                    "NO_CAM_MIC": "カメラとマイクが利用できません。",
                    "NO_CAM": "カメラが利用できません。",
                    "NO_MIC": "マイクが利用できません。",
                    "JOIN_VIDEO_AUDIO_MODAL": {
                        "TITLE": "ビデオ/音声共有に参加しますか？",
                        "MESSAGE": "ホストがビデオ/音声を有効にするよう求めています。",
                        "DENY": "拒否",
                        "ACCEPT": "許可"
                    },
                    "PUBLISHER" : {
                        "YOU": "あなた",
                        "SCREEN_SHARE_MESSAGE": "画面を共有します。",
                        "STOP_SCREEN_SHARING": "画面共有停止"
                    },
                    "SUBSCRIBER" : {
                        "APP_NOT_UP_TO_DATE_FOR_STATS": "この参加者のアプリが最新ではないため、ネットワークステータスを表示できません。",
                        "SNAPSHOT": "スナップショット",
                        "AR_PLUS": "AR コラボレーション",
                        "SCREENSHOT_REQUESTED": "スナップショットが要求されました",
                        "VIDEO_NOT_AVAILABLE": "ビデオは利用できません",
                        "WEAK_SIGNAL": "通信状況悪化",
                        "AUDIO_ONLY_MODE": "音声モード",
                        "FLASH": "フラッシュ",
                        "AR_NOT_AVAILABLE": "AR はこのデバイスでは利用できません。",
                        "CHARGING": "充電中",
                        "LOW_BATTERY": "バッテリー残量 少",
                        "CLOSE_AR_PLUS_MODAL": {
                            "TITLE": "AR+を閉じますか？",
                            "MESSAGE": "AR+を閉じてよろしいですか？",
                            "NO": "いいえ",
                            "YES": "はい"
                        },
                        "DISABLE_FOCUS_MODAL": {
                            "TITLE": "AR+を開きますか？",
                            "MESSAGE_AUTHORIZED": "ピン止めされたウィンドウが存在します。外してAR+を開始しますか？",
                            "MESSAGE_UNAUTHORIZED": "ピン止めされたウィンドウがあるためAR+を開始できませんでした。",
                            "CANCEL": "キャンセル",
                            "CLOSE": "閉じる",
                            "PROCEED": "続行"
                        },
                        "REFRESH_SURFACES": "サーフェスを更新",
                        "AR_PLUS_LOCKED": "AR+はロックされています。 最初にAR+のロックを解除してください。"
                    },
                    "CONTROL_BAR": {
                        "SHARE_SCREEN": "画面共有",
                        "STOP_SHARE": "画面共有停止",
                        "MIC_OFF": "マイク",
                        "CAM_OFF": "カメラ",
                        "CAM_MIC_CANT_ACCESS": "カメラもしくはマイクへアクセスできません。",
                        "LEAVE_CALL": "離れる",
                        "LEAVE_SESSION": "セッションを終了する",
                        "LEAVE_MEETING": "会議から退席する",
                        "END_SESSION_FOR_ALL": "すべてのセッションを終了",
                        "END_MEETING_FOR_ALL": "全員で会議を終了する",
                        "ENDCALL_MODAL": {
                            "TITLE_LEAVE": "セッションを終了する？",
                            "TITLE_LEAVE_MEETING": "会議を退席しますか?",
                            "TITLE_END_ALL": "すべてのセッションを終了？",
                            "TITLE_END_ALL_MEETING": "全員参加のミーティングを終了しますか?",
                            "MESSAGE_LEAVE": "セッションを終了してもよろしいですか？",
                            "MESSAGE_END_ALL": "セッションを終了してもよろしいですか？",
                            "MESSAGE_LEAVE_MEETING": "会議から退出してもよろしいですか?",
                            "MESSAGE_END_ALL_MEETING": "ミーティングを終了してもよろしいですか?",
                            "CANCEL": "キャンセル",
                            "END": "終了",
                            "LEAVE": "退出",
                            "REMOVE_MEETING_LINK": "会議リンクも無効にして削除します"
                        },
                        "RAISE_HAND": "手を挙げる",
                        "LOWER_HAND": "手を下げる",
                        "RECORD": "録画",
                        "AUTO_RECORD": "自動録画",
                        "STOP_RECORD": "録画停止",
                        "CANCEL": "リクエストのキャンセル",
                        "ASK_ARCHIVE_PERMISSION": "録画権限について尋ねる",
                        "REACTION": "リアクション",
                        "EXTENSION_MODAL_TITLE": "拡張機能が要求されました",
                        "EXTENSION_MODAL_MESSAGE": "Google Chromeで画面共有を行うには拡張機能が必要です。拡張機能をインストールするかFirefoxをお使いください。",
                        "EXTENSION_MODAL_NO": "キャンセル",
                        "EXTENSION_MODAL_YES": "拡張機能のページを開く",
                        "ARCHIVE_NO_PERMISSION": "このセッションを録画する権限がありません。管理者に連絡してください。",
                        "P2P_NO_ARCHIVE": "P2P通信では録画をすることができません。管理者に連絡してください。",
                        "SCREEN_SHARE_UPDATE": "現在のブラウザバージョンは画面共有をサポートしていません。 ブラウザを更新してください。",
                        "SCREEN_SHARE_NOT_SUPPORTED": "このブラウザは画面共有をサポートしていません。",
                        "SCREEN_SHARE_USE_OTHER": "このブラウザは画面共有をサポートしていません。Google ChromeかMozilla Firefoxをお使いください。",
                        "SCREEN_SHARE_FAILED": "画面共有ができません。",
                        "ARCHIVE_REQUESTED": "録画が開始されます。権限が必要です。",
                        "ARCHIVE_REQUESTED_WITH_NAME": "{{ name }}が録画を開始したがっています。あなたの許可が必要です。",
                        "DENY": "拒否",
                        "ALLOW": "許可"
                    },
                    "PDF_COLLABORATION": {
                        "PREVIOUS_PAGE": "前ページ",
                        "NEXT_PAGE": "次ページ"
                    },
                    "COLLABORATION_SHARED": {
                        "SOME_USERS_CANNOT_LOAD": "ファイルコラボレーションを読み込めなかったユーザーがいます。",
                        "DOWNLOAD_FAILED": "ファイルコラボレーションをダウンロードできません。",
                        "END_COLL_TITLE": "ファイルコラボレーションを閉じますか？",
                        "END_COLL_MESSAGE": "ファイルコラボレーションを閉じます。",
                        "END_COLL_NO": "キャンセル",
                        "END_COLL_YES": "続行",
                        "ALREADY_ENDED": "ファイルコラボレーションは既に終了しています。",
                        "CANNOT_END_COLLABORATION": "ファイルコラボレーションを終了できません。",
                        "ANNOTATE": "注釈",
                        "FULLSCREEN": "フルスクリーン",
                        "DOWNLOAD_COLLABORATION": "コラボレーションをダウンロードする",
                        "SNAPSHOT_COLLABORATION": "スナップショット",
                        "UNDO": "取り消し",
                        "REDO": "取り消しの取り消し",
                        "REVERT": "元に戻す",
                        "RELOAD": "リロード"
                    },
                    "TRY_TO_FOCUS_MODAL": {
                        "TITLE": "ウィンドウをピン止めしますか？",
                        "MESSAGE": "AR+中はピン止めできません。AR+を閉じてピン止めしますか？",
                        "CANCEL": "キャンセル",
                        "PROCEED": "続行"
                    }
                }
            },
            "RECONNECT_ROOM": {
                "RECONNECT_MESSAGE": "問題が発生したようです。通話に復帰しようとしています。"
            },
            "SESSION_RATING": {
                "BAD": "悪い",
                "POOR": "不十分",
                "FAIR": "平均",
                "GOOD": "良い",
                "EXCELLENT": "優秀な",
                "RATING_MESSAGE" : "セッションの質はどうでしたか？",
                "REVIEW_MESSAGE" : "理由を教えてください（オプション）",
                "SUCCESS_MESSAGE": "セッションを評価していただきありがとうございます。",
                "CLOSE": "閉じる",
                "SUBMIT": "送信",
                "DISMISS": "退出させる"
            },
            "PRECALL_TEST": {
                "BACK_TO_LOBBY": "ロビーへ戻る",
                "RUN_PRECALL_TEST": "接続テスト実行",
                "WHAT_TEST": {
                    "TITLE": "テストを開始します",
                    "CONNECTIVITY": "全てのメディアサーバーへの接続。",
                    "STATS": "ビットレートとパケットロスの統計を取っています。",
                    "SETUP": "エンドポイントのハードウェア・ソフトウェア設定 (カメラ, マイク, ブラウザ)。"
                },
                "BEFORE_START": {
                    "TITLE": "開始前",
                    "MAKE_SURE": "確認",
                    "RIGHT_NETWORK": "テストをしようとしているネットワーク上にいます。",
                    "TCP_PORT_OPEN": "TCPポートの443が開いている必要があります。",
                    "RIGHT_HARDWARE": "正しいカメラとマイクが選択されています。",
                    "BANDWITH": "アップロード・ダウンロード共に帯域幅は50kbpsを超えています。"
                },
                "HARDWARE_SOFTWARE": {
                    "TITLE": "ハードウェア/ソフトウェア設定",
                    "OPERATING_SYSTEM": {
                        "MESSAGE": "OS",
                        "BETTER_ALTERNATIVE_IOS": "より快適に使用するにはAppStoreから{{ appName }}リモートアプリをダウンロードしてください。",
                        "BETTER_ALTERNATIVE_ANDROID": "より快適に使用するにはGoogle Play Storeから{{ appName }}リモートアプリをダウンロードしてください。"
                    },
                    "BROWSER": {
                        "MESSAGE": "ブラウザ",
                        "NOT_SUPPORTED": "このブラウザはサポートされてていません。Google Chrome, Mozilla Firefox, Safari or Microsoft Edge (version 79以上)をお使いください。",
                        "NOT_COMPATIBLE": "このブラウザには互換性がありません。ブラウザをアップデートしてください。",
                        "USE_SAFARI": "このブラウザには互換性がありません。{{ appName }}リモートアプリもしくはSafariをお使いください。"
                    },
                    "HARDWARE": {
                        "MESSAGE": "カメラ/マイク 接続",
                        "CANT_ACCESS": "カメラ/マイクに接続できません。"
                    }
                },
                "CONNECTION_SERVERS": {
                    "TITLE": "VSightサーバーへの接続",
                    "INTERNET": {
                        "MESSAGE": "インターネット接続",
                        "OFFLINE": "インターネット接続がオフラインです"
                    },
                    "SERVERS": {
                        "MESSAGE": "VSightサーバーへの接続",
                        "UNKNOWN_ERROR_TRY": "VSightサーバーに接続中にエラーが発生しました。時間をおいて再度お試しください。",
                        "UNKNOWN_ERROR": "VSightサーバーに接続中にエラーが発生しました。"
                    }
                },
                "QUALITY": {
                    "TITLE": "音声/映像 品質",
                    "AUDIO_VIDEO": {
                        "MESSAGE": "音声/映像 品質",
                        "UNKNOWN_ERROR": "音声/映像 品質テスト中にエラーが発生しました。",
                        "VIDEO": "映像",
                        "VIDEO_QUALITY": "映像品質: ",
                        "VIDEO_PACKET_LOSS": "パケットロス: ",
                        "VIDEO_BITRATE": "映像ビットレート: ",
                        "AUDIO": "音声",
                        "AUDIO_QUALITY": "音声品質: ",
                        "AUDIO_PACKET_LOSS": "パケットロス: ",
                        "AUDIO_BITRATE": "音声ビットレート: ",
                        "QUALITY_EXCELLENT": "(素晴らしい)",
                        "QUALITY_GOOD": "(良い)",
                        "QUALITY_BAD": "(悪い)"
                    }
                },
                "STOP_TEST_MODAL": {
                    "TITLE": "テストを中止しますか？",
                    "MESSAGE": "テストを中止します。",
                    "NO": "キャンセル",
                    "YES": "中止"
                }
            },
            "EMAIL_RECIPIENTS": {
                "PLACEHOLDER": "新しく追加する",
                "SECONDARY_PLACEHOLDER": "メールアドレスを入力してください",
                "INVALID_EMAIL": "メール形式が無効です。"
            },
            "WORKFLOW_REMOTE": {
                "ERRORS": {
                    "INTEGRATION_ALREADY_USED": "統合はすでに使用されています",
                    "MISSING_PARAMETERS": "パラメータが不足しています",
                    "CALL_IN_PROGRESS": "通話中です",
                    "USER_IN_ANOTHER_ROOM": "別の部屋にいるユーザー"
                }
            }
        },
        "HELP_CENTER": {
            "TITLE": "{{ appName }} ヘルプセンター",
            "TITLE_WITH_REMOTE": "{{ appName }} Remote ヘルプセンター",
            "FAILED": "エラーが発生しました。"
        },
        "EXTERNALS": {
            "JOIN_WITH_LINK": {
                "TITLE": "{{appName}}リモートゲストアクセス",
                "SESSION_NOT_FOUND": "要求したセッションが見つかりませんでした。",
                "SESSION_NOT_AVAILABLE": "このセッションはもう利用できません。",
                "CONCURRENT_LIMIT_REACHED": "ユーザー数の上限に達しました。管理者に連絡してください。",
                "EXPERT_CONCURRENT_LIMIT_REACHED": "ルーム主催者数の上限に達しました。管理者に連絡してください。",
                "UNKNOWN_ERROR": "失敗。",
                "ABOUT_TO_JOIN": "参加しようとしています",
                "ENTER_NAME": "名前を入力",
                "NAME_REQUIRED": "名前が必要です",
                "NAME_SHORT": "名前には最低2文字必要です。",
                "JOIN": "参加",
                "CONTINUE_TO_WEBSITE": "ブラウザで続行"
            },
            "ARCHIVE_LIST": {
                "TITLE": "ビデオコール記録",
                "LOADING": "読み込み中",
                "LOAD_FAILED": "エラーが発生しました。",
                "CREATED_AT": "次の場所で作られました",
                "SIZE": "サイズ",
                "STATUS": "状態",
                "DOWNLOAD": "ダウンロード",
                "GENERATING": "リンク作成中",
                "CLICK_TO_DOWNLOAD": "ダウンロードするためにはクリックしてください",
                "AVAILABLE": "利用可能",
                "DISCONNECTED": "切断しました",
                "DELETED": "削除しました",
                "EXPIRED": "期限が切れました",
                "WAITING": "待機中",
                "FAILED": "失敗"
            },
            "AUTHENTICATE": {
                "MESSAGE": "エラーが発生しました。"
            },
            "AD_LOGIN": {
                "MESSAGE": "エラーが発生しました。"
            },
            "AD_ERROR": {
                "ACCOUNT_NOT_FOUND": "アカウントが Azure AD に接続されていません。",
                "PERMISSION_DENIED": "このページを表示する権限がありません。",
                "INTERNAL_ERROR": "エラーが発生しました。",
                "CONTACT_MAIL": "<strong>{{ contactMail }}</strong> まで連絡してください。"
            }
        },
        "TUTORIALS": {
            "TUTORIAL_LINK": "チュートリアルの表示",
            "NEXT": "次",
            "END": "終わる",
            "MIC_CAMERA": "マイクかカメラを開く/閉じる",
            "END_CALL": "セッションを終了する",
            "RECORD": "全てのセッションで録画を開始/終了",
            "SCREEN_SHARING": "他のユーザーに見せたい画面の共有を開始/終了する",
            "REACTION": "全員へリアクションを送る(会話でのコミュニケーションが十分でないときに便利です)",
            "OPEN_AR_PLUS": "AR+を開く",
            "DRAW_ON_SURFACE": "AR+のライブストリームで青い格子でハイライトされた表面をなぞる",
            "OPEN_AR": "ARを開く",
            "HOLD_TO_HIGHLIGHT": "ARのライブストリームで特定の場所をハイライトするにはクリックしてドラッグ",
            "TAKE_SNAPSHOT": "他のユーザーから高品質のスナップショットを受け取る",
            "NO_CAMERA": "他の参加者のカメラがオンである必要がある",
            "WAIT_OR_SKIP": "他のユーザーを待つかこの機能をスキップする",
            "COLLABORATE": "スナップショットを共有: 記入および図形, 特殊形状, テキストの配置",
            "OPEN_ANNOTATION": "注釈を開く",
            "SKETCH_ON_COLL": "コラボレーション上に記入",
            "END_TUTORIAL": "ここからいつでもチュートリアルを見ることができます",
            "USER_TUTORIAL": "ユーザーチュートリアル",
            "GUIDE": "このユーザーチュートリアルでは、プラットフォームを段階的に説明します",
            "DONT_SHOW": "二度と表示しない",
            "SKIP_TUTORIAL": "チュートリアルをスキップ",
            "CANCEL": "キャンセル",
            "SKIP": "スキップ",
            "ASK_AGAIN": "このチュートリアルをスキップしてもよろしいですか？"
        },
        "NOT_FOUND": {
            "PAGE_NOT_FOUND": "申し訳ありません。お探しのページは見つかりませんでした。",
            "NO_LONGER_AVAILABLE": "URLが間違っているか、お探しのページはもう利用できません。"
        },
        "DOWNLOADS": {
            "FILE_NOT_FOUND": "ファイルが見つかりません",
            "IF_DOWNLOAD_NOT_STARTED": "ダウンロードが始まらない場合は ",
            "CLICK_HERE": "こちら"
        },
    "PAGINATOR": {
        "ITEMS_PER_PAGE": "ページあたりの件数:",
        "NEXT_PAGE": "次のページ",
        "PREVIOUS_PAGE": "前のページ",
        "FIRST_PAGE": "最初のページ",
        "LAST_PAGE": "最後のページ",
        "RANGE": "{{length}} 件中 {{start}} – {{end}} 件",
        "RANGE_ZERO": "{{length}} 件中 0 件"
    }
}